export default __webpack_public_path__ + "static/bryson-56aa2121e87e29673013d420c0aaa6c4.png";